import { IPost } from "../../types";

interface JobDetailsModalProps {
  job: IPost;
  onClose: () => void;
}

const JobDetailsModal = ({ job, onClose }: JobDetailsModalProps) => {
  return (
    <div className="fixed inset-0 p-2 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">{job.title}</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            &times;
          </button>
        </div>

        <div className="space-y-4">
          <div className="flex items-center justify-between space-x-4">
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Category</h3>
              <p>{job.category}</p>
            </div>

            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Type</h3>
              <p>{job.postType}</p>
            </div>
          </div>
          <div className="flex items-center justify-between space-x-4">
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Salary</h3>
              <p>₦{job.salary.toLocaleString()}</p>
            </div>

            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Location</h3>
              <p>
                {job.address}, {job.state}, {job.country}
              </p>
            </div>
          </div>
          <div className="flex items-center justify-between space-x-4">
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Experience</h3>
              <p>{job.experience}</p>
            </div>

            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">
                Qualifications
              </h3>
              <p>{job.qualifications}</p>
            </div>
          </div>
          <div className="flex items-center justify-between space-x-4">
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Skills</h3>
              <p>{job.skills.join(", ")}</p>
            </div>
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Status</h3>
              <p
                className={`capitalize ${
                  job.status === "open" ? "text-emerald-500" : "text-rose-500"
                }`}
              >
                {job.status}
              </p>
            </div>
          </div>

          <div>
            <h3 className="font-medium text-gray-500 text-sm">Description</h3>
            <div
              dangerouslySetInnerHTML={{ __html: job.description }}
              className="prose"
            />
          </div>
        </div>

        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-rose-500 text-rose-500 rounded-md"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default JobDetailsModal;
